module.exports = __webpack_public_path__ + "public/images/header-slide-2.6b3fe16fe0a79de7d0508a89f562da89.jpg";